// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.p-multiselect .p-multiselect-label.p-placeholder {
  font-size: 0.89rem !important;
  color: #999999;
}

.CustomSort_sortItem__Kn5kM {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
}

.CustomSort_sortLabel__\\+D00g {
  font-weight: 400;
  line-height: 16.34px;
  font-size: 12px;
  color: #495057;
}

.CustomSort_filterMobileItem__6ja4a {
  background-color: rgba(135, 60, 170, 0.1);
  border-radius: 16px;
  padding: 3px 10.5px;
  font-size: 14px;
  color: #4b5563;
  font-weight: 400;
  display: inline-flex;
  /* Ensures width adapts to content */
  align-items: center;
  justify-content: center;
  max-width: max-content;
  /* Avoid full width */
  white-space: nowrap;
  /* Prevents text from wrapping */
  margin-right: 10px;
  margin-bottom: 10px;
}

.CustomSort_filterMobileItemIcon__kJZnD {
  background-color: transparent;
  color: #4b5563;
  border: none !important;
  padding: 0px;
}

.CustomSort_filterMobileItemIcon__kJZnD:focus {
  box-shadow: none !important;
}

.CustomSort_sortingWrapper__VBvEX {
  display: flex;
  justify-content: start;
  align-items: center;
  min-width: 200px;
}

.CustomSort_headerItem__HPOxs {
  display: flex;
  align-items: center;
  justify-content: start;
  padding: 0px 0px 0px 0px;
  gap: 5px;
}

.CustomSort_sortingItem__GDVJ2 {
  width: 100%;
  padding: 0px;
}

.CustomSort_headerLabel__fS17q {
  font-weight: 700;
  font-size: 12px;
  line-height: 16.34px;
  color: #495057;
  width: 60px;
}

.CustomSort_sortItemBorder__ijBYT {
  border-style: solid;
  border-width: 1px;
  border-color: var(--branded-purple-border);
}

.CustomSort_sortDirectionIcon__1ANlN {
  border: 1px solid var(--branded-purple-border);
  border-radius: 5px;
  padding: 6px 15px;
  color: var(--branded-purple);
  font-size: 12px;
  background-color: white;
}

.CustomSort_sortDirectionIconSmall__S4yHX {
  border: 1px solid var(--branded-purple-border);
  border-radius: 5px;
  padding: 4px 8px;
  color: var(--branded-purple);
  font-size: 12px;
  margin-left: 10px;
  background-color: white;
}

@media (max-width: 768px) {
  .CustomSort_sortingWrapper__VBvEX {
    width: 100%;
  }

  .CustomSort_headerItem__HPOxs {
    display: flex;
    align-items: center;
    justify-content: start;
    flex-wrap: wrap;
    padding: 10px 0px 10px 0px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/CustomSort.module.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,oCAAoC;EACpC,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,wBAAwB;EACxB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,0CAA0C;AAC5C;;AAEA;EACE,8CAA8C;EAC9C,kBAAkB;EAClB,iBAAiB;EACjB,4BAA4B;EAC5B,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,8CAA8C;EAC9C,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,0BAA0B;EAC5B;AACF","sourcesContent":[":global(.p-multiselect .p-multiselect-label.p-placeholder) {\n  font-size: 0.89rem !important;\n  color: #999999;\n}\n\n.sortItem {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n}\n\n.sortLabel {\n  font-weight: 400;\n  line-height: 16.34px;\n  font-size: 12px;\n  color: #495057;\n}\n\n.filterMobileItem {\n  background-color: rgba(135, 60, 170, 0.1);\n  border-radius: 16px;\n  padding: 3px 10.5px;\n  font-size: 14px;\n  color: #4b5563;\n  font-weight: 400;\n  display: inline-flex;\n  /* Ensures width adapts to content */\n  align-items: center;\n  justify-content: center;\n  max-width: max-content;\n  /* Avoid full width */\n  white-space: nowrap;\n  /* Prevents text from wrapping */\n  margin-right: 10px;\n  margin-bottom: 10px;\n}\n\n.filterMobileItemIcon {\n  background-color: transparent;\n  color: #4b5563;\n  border: none !important;\n  padding: 0px;\n}\n\n.filterMobileItemIcon:focus {\n  box-shadow: none !important;\n}\n\n.sortingWrapper {\n  display: flex;\n  justify-content: start;\n  align-items: center;\n  min-width: 200px;\n}\n\n.headerItem {\n  display: flex;\n  align-items: center;\n  justify-content: start;\n  padding: 0px 0px 0px 0px;\n  gap: 5px;\n}\n\n.sortingItem {\n  width: 100%;\n  padding: 0px;\n}\n\n.headerLabel {\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 16.34px;\n  color: #495057;\n  width: 60px;\n}\n\n.sortItemBorder {\n  border-style: solid;\n  border-width: 1px;\n  border-color: var(--branded-purple-border);\n}\n\n.sortDirectionIcon {\n  border: 1px solid var(--branded-purple-border);\n  border-radius: 5px;\n  padding: 6px 15px;\n  color: var(--branded-purple);\n  font-size: 12px;\n  background-color: white;\n}\n\n.sortDirectionIconSmall {\n  border: 1px solid var(--branded-purple-border);\n  border-radius: 5px;\n  padding: 4px 8px;\n  color: var(--branded-purple);\n  font-size: 12px;\n  margin-left: 10px;\n  background-color: white;\n}\n\n@media (max-width: 768px) {\n  .sortingWrapper {\n    width: 100%;\n  }\n\n  .headerItem {\n    display: flex;\n    align-items: center;\n    justify-content: start;\n    flex-wrap: wrap;\n    padding: 10px 0px 10px 0px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sortItem": `CustomSort_sortItem__Kn5kM`,
	"sortLabel": `CustomSort_sortLabel__+D00g`,
	"filterMobileItem": `CustomSort_filterMobileItem__6ja4a`,
	"filterMobileItemIcon": `CustomSort_filterMobileItemIcon__kJZnD`,
	"sortingWrapper": `CustomSort_sortingWrapper__VBvEX`,
	"headerItem": `CustomSort_headerItem__HPOxs`,
	"sortingItem": `CustomSort_sortingItem__GDVJ2`,
	"headerLabel": `CustomSort_headerLabel__fS17q`,
	"sortItemBorder": `CustomSort_sortItemBorder__ijBYT`,
	"sortDirectionIcon": `CustomSort_sortDirectionIcon__1ANlN`,
	"sortDirectionIconSmall": `CustomSort_sortDirectionIconSmall__S4yHX`
};
export default ___CSS_LOADER_EXPORT___;
